
$(document).ready(function() {
    function hideEmptyStoreAvailability() {
        $("[data-retail-container]").each(function() {
            var dots;
            if ($(this).find("[data-retail-availability].active").length < 1) $(this).hide(); else $(this).show();
        });
    }
    function updateStoreAvailabilityDots() {
        $("[data-retail-availability]").removeClass("active");
        $(".product-single__variants").each(function() {
            var retail_variant_id = $(".product-form .form input[name='id']") && $(".product-form .form input[name='id']").val()
            if (0 < $("[data-retail-availability]").length && retail_variant_id) {
                $("[data-retail-availability=" + retail_variant_id + "]").each(function() {
                    $(this).addClass("active");
                });
            }
            hideEmptyStoreAvailability();
        });
    }

    if ($(".meta-suit").length) updateStoreAvailabilityDots();
    $(".product-form .form input[name='id']").change(function() {
        updateStoreAvailabilityDots();
    });
});